import { Section } from "@mittwald/flow-components/dist/components/Section";
import TranslationProvider from "@mittwald/flow-components/dist/components/TranslationProvider/TranslationProvider";
import React from "react";
import { StepHeaderItem } from "../../StepHeaderItem";
import { LoginInputs } from "./components/LoginInputs";

interface LoginStepContentProps {
  isNewSystem: boolean;
  formError?: string | null;
}

export const LoginStepContent: React.FC<LoginStepContentProps> = ({
  isNewSystem,
  formError,
}) => {
  return (
    <TranslationProvider name="loginStepContent" type="component">
      <Section.Layout>
        <StepHeaderItem
          description={{
            id: "description",
            values: {
              system: isNewSystem ? "mStudio" : "Kundencenter",
            },
          }}
          headline="headline"
        />
        <LoginInputs formError={formError} isNewSystem={isNewSystem} />
      </Section.Layout>
    </TranslationProvider>
  );
};
